import { RecommendationStoreState } from './types';

export const defaultState: RecommendationStoreState = {
    items: [],
};
